import { type ComponentStyleConfig } from "@chakra-ui/react";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Text = (): ComponentStyleConfig => ({
	baseStyle: {
		fontFamily: "body",
		fontSize: ["md", null, null, "xmd"],
		fontWeight: "normal",
		lineHeight: "taller",
	},
	sizes: {
		bodyXs: {
			fontSize: "xxs",
			lineHeight: "tall",
		},
		bodyS: {
			fontSize: "xs",
			lineHeight: "tall",
		},
		bodyM: {
			fontSize: "md",
			lineHeight: "tall",
		},
		bodyL: {
			fontSize: ["md", null, null, "xmd"],
			fontWeight: "normal",
			lineHeight: "taller",
		},
		quoteSign: {
			fontFamily: "icons",
			fontSize: ["5xl", null, null, "6xl"],
			lineHeight: ["shorter", null, null, "none"],
		},
	},
	variants: {},
});

